export default __webpack_public_path__ + "static/media/money-icon.dc91b84f.svg";